/**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
export function getSizedImageUrl (src, size) {
    if (size === null || src === null) {
        return src
    }
    if (size === 'master') {
        return this.removeProtocol(src)
    }
    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i)
    if (match) {
        var prefix = src.split(match[0])
        var suffix = match[0]
        return removeProtocol(prefix[0] + '_' + size + suffix)
    } else {
        return null
    }
}
export function removeProtocol (path) {
    return path.replace(/http(s)?:/, '')
}
export function getPrice (price) {
    var currency = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.querySelector('[data-currency]').dataset.currency
    var currencySign = void 0
    switch (currency) {
    case 'GBP':
        currencySign = '£'
        break
    case 'USD':
        currencySign = '$'
        break
    case 'EUR':
        currencySign = '€'
        break
    case 'AUD':
        currencySign = '$'
        break
    }
    var priceFormatted = price / 100
    var priceDecimals = priceFormatted.toFixed(2)
    var returnPrice = '' + currencySign + priceDecimals
    if (!returnPrice.includes('.')) {
        returnPrice = returnPrice + '.00'
    }
    return returnPrice
}



// WEBPACK FOOTER //
// ./src/resources/scripts/helpers/shopify.js